import {IPromiseRequest} from "../../index";
import {TServiceName} from "../../constants/ApiServices";
import {TSearchParams} from "../../util/request";

interface ISelectParams<T> {
    asc?: boolean
    autoSelect?: boolean // if there is only one item should it be autoselected
    data?: T[] | KnockoutObservableArray<T> // data input
    disable?: KnockoutObservable<boolean>
    enable?: KnockoutObservable<boolean>
    eventCreated?: string
    eventReset?: string
    exclude?: T[] | KnockoutObservableArray<T> // key must also be defined
    fnFilter?: ((value: T, index?: number, array?: T[]) => boolean)
    fnGetInitialItem?: (item: T) => boolean
    icon?: string
    inline?: boolean
    key?: keyof T & string
    map?: string
    options?: Partial<ISelectOptions<T>>
    results?: KnockoutObservableArray<T> // data output; if given, this observable is populated on a successful load
    selected: KnockoutObservable<T | any> // currently selected value
    onSelected?: (obj: T) => void,
    sortBy?: ((obj: T, index?: number, array?: T[]) => string | number) | keyof T | (keyof T)[]
    value?: T[keyof T] // key must also be defined // todo buggy?
    interface?: any
}

interface ISelectBaseParams<T> extends ISelectParams<T> {
    api: IApiOptions | TServiceName
}

interface ISelectArrayParams<T> extends ISelectParams<T> {
    data: T[] | KnockoutObservableArray<T>
}

interface IApiOptions {
    params?: TSearchParams
    name: TServiceName
    isSearch?: boolean
    promiseRequest?: IPromiseRequest;
}

interface ISelectOptions<T> {
    // user prompt
    caption: string
    // default caption value
    defaultvalue?: any
    // displayed value attribute
    text: string | string[] | ((obj: T) => string) | boolean
    // the value attribute
    value: any | ((obj: T) => any)
    // the title attribute
    title: string | string[] | ((obj: T) => string)
    // the option's css
    style: string | ((obj: T) => string)
}
